import { render } from "./CommentEditor.vue?vue&type=template&id=1977c6ba"
import script from "./CommentEditor.vue?vue&type=script&lang=js"
export * from "./CommentEditor.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__